import { render, staticRenderFns } from "./trainSignConfirm.vue?vue&type=template&id=4f262833&scoped=true&"
import script from "./trainSignConfirm.vue?vue&type=script&lang=js&"
export * from "./trainSignConfirm.vue?vue&type=script&lang=js&"
import style0 from "./trainSignConfirm.vue?vue&type=style&index=0&id=4f262833&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f262833",
  null
  
)

export default component.exports